/**
 * React-only shared runtime for embedded stock MFEs.
 * MUI/Emotion are loaded asynchronously via ensureMfeUiShared() so they do not
 * block the host's initial main.js parse on hard refresh.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import * as ReactJSXRuntime from 'react/jsx-runtime';
import * as ReactJSXDevRuntime from 'react/jsx-dev-runtime';

const shared = {
  react: React,
  'react-dom': ReactDOM,
  'react-dom/client': ReactDOMClient,
  'react/jsx-runtime': ReactJSXRuntime,
  'react/jsx-dev-runtime': ReactJSXDevRuntime,
};

if (typeof window !== 'undefined') {
  window.__MFE_SHARED__ = {
    ...(window.__MFE_SHARED__ || {}),
    ...shared,
  };
}

let uiSharedPromise = null;

/** Load MUI + Emotion into window.__MFE_SHARED__ (idempotent). */
export function ensureMfeUiShared() {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }
  if (window.__MFE_SHARED__?.['@mui/material'] && window.__MFE_SHARED__?.['@emotion/react']) {
    return Promise.resolve(window.__MFE_SHARED__);
  }
  if (!uiSharedPromise) {
    uiSharedPromise = import('./mfeSharedUiRuntime')
      .then((mod) => {
        Object.assign(window.__MFE_SHARED__, mod.sharedUi);
        return window.__MFE_SHARED__;
      })
      .catch((err) => {
        uiSharedPromise = null;
        throw err;
      });
  }
  return uiSharedPromise;
}

export default shared;
